import { SchedulerTranslationsTokens } from '../tokens'

export const SchedulerFrenchTranslation: Record<
	SchedulerTranslationsTokens,
	string
> = {
	[SchedulerTranslationsTokens.confirm]: 'Confirmer',
	[SchedulerTranslationsTokens.confirm_meeting_header]:
		'Votre réunion a bien été programmée !',
	[SchedulerTranslationsTokens.confirm_meeting_description]:
		'Les détails de la réunion vous ont été envoyés. Veuillez vérifier votre boîte de réception.',
	[SchedulerTranslationsTokens.reschedule_meeting]: 'Reprogrammer la réunion',
	[SchedulerTranslationsTokens.cancel_meeting]: 'Annuler la réunion',
	[SchedulerTranslationsTokens.confirm_meeting_has_assigned]:
		'a été assigné(e) à votre réunion.',
	[SchedulerTranslationsTokens.confirm_meeting_invite_teammates]:
		"Inviter des membres de l'équipe",
	[SchedulerTranslationsTokens.confirm_meeting_send_invites]:
		'Envoyer les invitations',
	[SchedulerTranslationsTokens.confirm_meeting_email_error]:
		'Veuillez saisir des adresses e-mail valides',
	[SchedulerTranslationsTokens.confirm_meeting_error_sending_invites]:
		"L'envoi des invitations a échoué !",
	[SchedulerTranslationsTokens.cancel_meeting_reason]:
		'Pourquoi annulez-vous cette réunion ? (Facultatif)',
	[SchedulerTranslationsTokens.cancel_meeting_reason_details]:
		'Partagez quelques détails ici',
	[SchedulerTranslationsTokens.cancel_meeting_header]:
		'Votre réunion a été annulée !',
	[SchedulerTranslationsTokens.cancel_meeting_description]:
		"Nous informerons tous les participants de l'annulation.",
	[SchedulerTranslationsTokens.cancel_by_mistake]: 'Annulé par erreur ?',
	[SchedulerTranslationsTokens.cancel_reschedule_msg]:
		'Vous pouvez reprogrammer cette réunion avec un nouveau créneau.',
	[SchedulerTranslationsTokens.rescheduling_header]: 'Reprogrammer la réunion',
	[SchedulerTranslationsTokens.keep_original_time]: "Conserver l'horaire",
	[SchedulerTranslationsTokens.former_time]: 'Horaire précédent',
	[SchedulerTranslationsTokens.powered_by]: 'Développé par',

	[SchedulerTranslationsTokens.no_event]: 'Aucun événement trouvé !',
	[SchedulerTranslationsTokens.no_event_active]:
		"Cet événement n'est plus actif !",
	[SchedulerTranslationsTokens.no_member]: 'Aucun membre trouvé !',
	[SchedulerTranslationsTokens.no_queue]: 'Aucun groupe trouvé !',
	[SchedulerTranslationsTokens.no_queue_active]: "Ce groupe n'est plus actif !",
	[SchedulerTranslationsTokens.no_meeting]: 'Aucune réunion trouvée !',
	[SchedulerTranslationsTokens.no_time_slots]:
		'Aucun créneau horaire disponible !',
	[SchedulerTranslationsTokens.minutes_meeting]: 'min réunion',

	[SchedulerTranslationsTokens.weekdays_short]: 'Dim_Lun_Mar_Mer_Jeu_Ven_Sam',
	[SchedulerTranslationsTokens.time_slots]: 'Créneaux',

	[SchedulerTranslationsTokens.morning]: 'Matin',
	[SchedulerTranslationsTokens.afternoon]: 'Après-midi',
	[SchedulerTranslationsTokens.evening]: 'Soir',

	[SchedulerTranslationsTokens.timeslot_loading]:
		'Récupération des créneaux disponibles...',
	[SchedulerTranslationsTokens.timer_warning]:
		'Réservez dans les {delay} prochaines minutes pour confirmer votre session.',
	[SchedulerTranslationsTokens.timer_warning_v2]:
		'Finalisez votre réservation dans les',
	[SchedulerTranslationsTokens.conferencing_details_on_invite]:
		"Détails de conférence dans l'invitation",
	[SchedulerTranslationsTokens.future_meeting_details_header]:
		'Vous avez déjà une réunion programmée !',
	[SchedulerTranslationsTokens.future_meeting_details_description]:
		"Pour la reprogrammer ou l'annuler, utilisez les options ci-dessous.",
}
